import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { home } from "../content/home";
import { useContent, Rich, SlotVideo, SlotImg, HashLink, prefersReducedMotion } from "../ui/helpers";

const DURATION = 8000; // ms each slide stays on screen

export function HeroCarousel({ onFilm }) {
  const c = useContent(home).hero;
  const [cur, setCur] = useState(0);
  const [paused, setPaused] = useState(prefersReducedMotion);
  const [cycle, setCycle] = useState(0); // restarts the progress bar animation

  useEffect(() => {
    if (paused) return undefined;
    const t = setTimeout(() => go(cur + 1), DURATION);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cur, paused, cycle]);

  const go = (i) => { setCur((i + c.slides.length) % c.slides.length); setCycle((n) => n + 1); };

  return (
    <section className={`hero${paused ? " paused" : ""}`} aria-roledescription="carousel" aria-label={c.label} style={{ "--dur": `${DURATION}ms` }}>
      {c.slides.map((s, i) => {
        const Title = i === 0 ? "h1" : "h2";
        return (
          <div key={s.media} className={`slide${i === cur ? " on" : ""}`} aria-roledescription="slide" aria-label={`${i + 1} / ${c.slides.length}`} aria-hidden={i !== cur}>
            <SlotVideo slot={s.media} playing={i === cur && !paused} />
            <div className="slide-copy"><div className="k-wrap"><div>
              <p className="k-label anim"><Rich text={s.eyebrow} /></p>
              <Title className="hero-title anim"><Rich text={s.title} /></Title>
              <p className="hero-lead anim"><Rich text={s.lead} /></p>
              <div className="hero-ctas anim">
                <HashLink className="k-btn k-btn-mint" href={s.cta.href} tabIndex={i === cur ? 0 : -1}>
                  {s.cta.label} <span className="ar" aria-hidden="true">→</span>
                </HashLink>
                {s.cta2 && <Link className="k-btn k-btn-ghost" to={s.cta2.to} tabIndex={i === cur ? 0 : -1}>{s.cta2.label}</Link>}
              </div>
            </div></div></div>
          </div>
        );
      })}

      <button className="film-card" type="button" onClick={onFilm}>
        <span className="film-thumb"><SlotImg slot="film.thumb" eager decorative sizes="120px" /></span>
        <span><strong>{c.filmTitle}</strong><small>{c.filmMeta}</small></span>
      </button>

      <div className="hero-bar">
        <div className="k-wrap hero-bar-in" role="tablist" aria-label={c.label}>
          {c.slides.map((s, i) => (
            <button key={`${s.media}-${i === cur ? cycle : "x"}`} type="button" role="tab" aria-selected={i === cur}
              className={`tab${i === cur ? " on" : ""}`} onClick={() => go(i)}>
              <i /><b>{(() => { const [n, ...rest] = String(s.tab.key).split(/\s+·\s+/); return rest.length ? <>{n}<span className="tab-k"> · {rest.join(" · ")}</span></> : n; })()}</b><span>{s.tab.text}</span>
            </button>
          ))}
          <div className="hero-ctrl">
            <button type="button" className="icon-btn" aria-label={paused ? c.play : c.pause} onClick={() => setPaused((p) => !p)}>
              {paused
                ? <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M3 1.5l7 4.5-7 4.5z" fill="currentColor" /></svg>
                : <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M3 2v8M9 2v8" stroke="currentColor" strokeWidth="2" /></svg>}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
